import React from 'react';
import './ModalNewUser.css'

const ModalNoStatement = ({showNoState, setShowNoState, btnNo, statementNo, TaskClose, TaskCloseBtn, TaskNew, TaskNewBtn}) => {


    const noCloseTaskWithStatement = (statementNo, TaskNew) => {
        btnNo(statementNo)
        TaskNewBtn(TaskNew)
        setShowNoState(false)
    }

    const closeTaskWithStatement = (statementNo, TaskClose) => {
        btnNo(statementNo)
        TaskCloseBtn(TaskClose)
        setShowNoState(false)
    }

    return (
        <div className={showNoState ? "modal active" : "modal"} onClick={() => setShowNoState(false)}>
            <div className={showNoState ? "modal__content active" : "modal__content"} onClick={e => e.stopPropagation()}>

                <h2>После отказа закрыть задачу?</h2>
                <div className="user__del_btn__block">
                    <button className='btn__yes' onClick={() => closeTaskWithStatement(statementNo, TaskClose)}>Да</button>
                    <button className='btn__no' onClick={() => noCloseTaskWithStatement(statementNo, TaskNew)}>Нет</button>
                </div>


            </div>
        </div>
    );
};

export default ModalNoStatement;